import { useAssignUserRoleMutation } from './useAssignUserRoleMutation';
import { useCreateUserMutation } from './useCreateUserMutation';
import { useDeleteUserImageMutation } from './useDeleteUserImageMutation';
import { useDeleteUserMutation } from './useDeleteUserMutation';
import { useAddFavouriteEventMutation } from './useAddFavouriteEventMutation';
import { useRemoveFavouriteEventMutation } from './useRemoveFavouriteEventMutation';
import { useRemoveUserRoleMutation } from './useRemoveUserRoleMutation';
import { useUpdateUserImageMutation } from './useUpdateUserImageMutation';
import { useUpdateUserMutation } from './useUpdateUserMutation';

export const useUserMutations = () => {
    const create = useCreateUserMutation();
    const update = useUpdateUserMutation();
    const del = useDeleteUserMutation();
    const updateImage = useUpdateUserImageMutation();
    const deleteImage = useDeleteUserImageMutation();
    const addFavourite = useAddFavouriteEventMutation();
    const removeFavourite = useRemoveFavouriteEventMutation();
    const assignRole = useAssignUserRoleMutation();
    const removeRole = useRemoveUserRoleMutation();
    return {
        add: create,
        update: update,
        remove: del,
        updateImage: updateImage,
        deleteImage: deleteImage,
        addFavourite: addFavourite,
        removeFavourite: removeFavourite,
        assignRole: assignRole,
        removeRole: removeRole,
        isLoading:
            create.isLoading ||
            update.isLoading ||
            del.isLoading ||
            updateImage.isLoading ||
            deleteImage.isLoading ||
            addFavourite.isLoading ||
            removeFavourite.isLoading ||
            assignRole.isLoading ||
            removeRole.isLoading,
        error:
            create.mutate.error ||
            update.mutate.error ||
            del.mutate.error ||
            updateImage.mutate.error ||
            deleteImage.mutate.error ||
            addFavourite.mutate.error ||
            removeFavourite.mutate.error ||
            assignRole.mutate.error ||
            removeRole.mutate.error,
    };
};
